module.exports = __webpack_public_path__ + "img/entity_02.044cbea9.jpg";